import IntroGmg from '../intro-gmg';
import EDC from '../../../../components/games/shared/globals';
import router from '@/router/index';

/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main = function () {
  this.border = null;
  this.logoAnim = null;
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main.prototype.create = function () {
  const gameWidth = this.game.config.width;
  const gameHeight = this.game.config.height;

  const bg = this.add.graphics(0, 0);
  bg.fillStyle(0xffffff, 1);
  bg.fillRect(0, 0, gameWidth, gameHeight);

  this.logoAnim = new IntroGmg(this).create(this.showBorder.bind(this));
  this.logoAnim.start();
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main.prototype.showBorder = function () {
  const gameWidth = this.game.config.width;
  const gameHeight = this.game.config.height;

  this.border = this.add.sprite(gameWidth / 2, gameHeight / 2, 'border');
  this.border.setAlpha(0);
  this.tweens.add({
    targets: this.border,
    alpha: 1,
    duration: 300,
    ease: 'Linear',
    onComplete: this.moveUp.bind(this),
  });
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main.prototype.moveUp = function () {
  const logoImg = this.logoAnim.getImage();
  this.tweens.add({
    targets: [this.border, logoImg],
    y: { value: `-=${100}` },
    duration: 600,
    ease: 'Linear',
    onComplete: this.showLetters.bind(this),
  });
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main.prototype.showLetters = function () {
  const letters = [];
  let commonWidth = 0;
  const letterCount = 3;
  for (let i = 0; i < letterCount; i++) {
    const letter = this.add.sprite(0, 0, `letter${i}`);
    letters.push(letter);
    commonWidth += letter.displayWidth;
  }
  const step = 0;
  commonWidth += step * (letterCount - 1);

  const targetY = this.border.y + this.border.displayHeight / 2;

  let x = (this.game.config.width - commonWidth) / 2 + letters[0].displayWidth / 2;
  for (let i = 0; i < letters.length; i++) {
    const letter = letters[i];
    letter.x = x;
    letter.y -= letter.displayHeight / 2;
    x += letter.displayWidth + step;
    this.tweens.add({
      targets: letter,
      y: targetY + letter.displayHeight / 2,
      duration: 2000,
      ease: 'Bounce.easeOut',
      delay: i * 100,
      onComplete: function (index, count) {
        if (index >= count - 1) {
          this.lettersComplete();
        }
      }.bind(this, i, letterCount),
    });
  }
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Main.prototype.lettersComplete = function () {
  if (router.currentRoute.name === 'intro') {
    setTimeout(() => {
      router.push({ name: 'main-menu' });
    }, 3000);
  }
};

export default EDC.Games.TitleIntro.Scenes.Main;
